export enum DOCUMENT_FILE_TYPE_ID {
  SPREAD_SHEET = 'SPREAD_SHEET',
  TERM_SHEET = 'TERM_SHEET',
  KID = 'KID',
  FINAL_TERMS = 'FINAL_TERMS',
  OTHER = 'OTHER',
}
